import { type DashRouteType, URL_PARTNER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_ITEM_PRICE_MANAGEMENT = `${URL_PARTNER_SCOPED}/item-price-management`
const URL_ITEM_PRICE_MANAGEMENT_ACTIVE_RULES = `${URL_ITEM_PRICE_MANAGEMENT}/active-rules`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUESTS = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_CREATE = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/new`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_DETAIL = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/:changeRequestId`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_EDIT = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/:changeRequestId/edit`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_REVIEW = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/:changeRequestId/review`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_PARTNER_REVIEW = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/:changeRequestId/review-partner`
const URL_ITEM_PRICE_MANAGEMENT_PRODUCT_LIST_EDIT = `${URL_ITEM_PRICE_MANAGEMENT}/product-lists/:productListId/edit`
const URL_ITEM_PRICE_MANAGEMENT_PRODUCT_LIST_DETAIL = `${URL_ITEM_PRICE_MANAGEMENT}/product-lists/:productListId`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'item-price-management'>
  | DashRouteType<'item-price-management-active-rules'>
  | DashRouteType<'item-price-management-change-requests'>
  | DashRouteType<'item-price-management-change-request-create'>
  | DashRouteType<'item-price-management-change-request-detail'>
  | DashRouteType<'item-price-management-change-request-edit'>
  | DashRouteType<'item-price-management-change-request-review'>
  | DashRouteType<'item-price-management-change-request-partner-review'>
  | DashRouteType<'item-price-management-product-list-edit'>
  | DashRouteType<'item-price-management-product-list-detail'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'item-price-management': URL_ITEM_PRICE_MANAGEMENT,
  'item-price-management-active-rules': URL_ITEM_PRICE_MANAGEMENT_ACTIVE_RULES,
  'item-price-management-change-requests': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUESTS,
  'item-price-management-change-request-create': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_CREATE,
  'item-price-management-change-request-detail': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_DETAIL,
  'item-price-management-change-request-edit': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_EDIT,
  'item-price-management-change-request-review': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_REVIEW,
  'item-price-management-change-request-partner-review':
    URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_PARTNER_REVIEW,
  'item-price-management-product-list-edit': URL_ITEM_PRICE_MANAGEMENT_PRODUCT_LIST_EDIT,
  'item-price-management-product-list-detail': URL_ITEM_PRICE_MANAGEMENT_PRODUCT_LIST_DETAIL,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
